/**
 * 리포트 저장 — 휴대폰에서도 되도록.
 *
 * 기존에는 페이지 전체를 window.print() 했는데, 리포트 본문이 iframe 안에 있어서
 * 휴대폰에서는 내용이 잘리거나 인쇄 창이 아예 안 뜨는 경우가 많았다
 * (특히 카카오톡·인스타 등 앱 안에서 열었을 때).
 *
 * 그래서 리포트 본문만 새 창에 띄워 인쇄(→PDF로 저장)하고,
 * 새 창이 막히면 HTML 파일로 내려받게 한다.
 */

/** 카카오톡·네이버·인스타 등 앱 안에서 열린 브라우저인지 */
export function isInAppBrowser(): boolean {
  const ua = navigator.userAgent || "";
  return /KAKAOTALK|NAVER|Instagram|FBAN|FBAV|Line|DaumApps|everytimeApp/i.test(ua);
}

function downloadHtml(html: string, filename: string) {
  const blob = new Blob(["﻿" + html], { type: "text/html;charset=utf-8" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename.endsWith(".html") ? filename : `${filename}.html`;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  setTimeout(() => URL.revokeObjectURL(url), 4000);
}

/**
 * 리포트 저장 실행.
 * @param html      리포트 본문 HTML (없으면 현재 페이지를 인쇄)
 * @param filename  내려받기로 넘어갈 때 쓸 파일명
 */
export function saveReport(html?: string, filename = "우연사주_리포트"): void {
  if (!html) {
    window.print();
    return;
  }
  // 인쇄용 창: 본문만 담고 여백/폰트만 정리
  const doc = html.includes("<html")
    ? html.replace("</head>", `<style>@page{margin:12mm;} body{-webkit-print-color-adjust:exact;print-color-adjust:exact;}</style></head>`)
    : `<!doctype html><html lang="ko"><head><meta charset="utf-8">
       <meta name="viewport" content="width=device-width,initial-scale=1">
       <title>${filename}</title>
       <style>@page{margin:12mm;} body{margin:0;-webkit-print-color-adjust:exact;print-color-adjust:exact;
       font-family:'Pretendard','Apple SD Gothic Neo','Malgun Gothic',sans-serif;}</style>
       </head><body>${html}</body></html>`;

  const w = window.open("", "_blank");
  if (!w) {                      // 새 창이 막힌 경우(앱 내 브라우저 등)
    downloadHtml(doc, filename);
    return;
  }
  try {
    w.document.open();
    w.document.write(doc);
    w.document.close();
    // 이미지·폰트가 자리잡을 시간을 준 뒤 인쇄 창을 띄운다
    const fire = () => { try { w.focus(); w.print(); } catch { /* 사용자가 직접 인쇄해도 됨 */ } };
    if (w.document.readyState === "complete") setTimeout(fire, 400);
    else w.onload = () => setTimeout(fire, 400);
  } catch {
    downloadHtml(doc, filename);
  }
}
